import { cn, useFileSelector } from "@synthesis/shared-utils";
import { observer } from "mobx-react-lite";
import { useCallback, useEffect } from "react";

import { buildCreateApplicationDocumentTableRows, usePageStore } from "../../create-application-page.lib";
import { CreateApplicationDocumentsHelpSection } from "./create-application-documents-help-section";
import { CreateApplicationDocumentsList } from "./create-application-documents-list";

type CreateApplicationDocumentsStepProps = {
  className?: string;
};

export const CreateApplicationDocumentsStep = observer(({ className }: CreateApplicationDocumentsStepProps) => {
  const pageStore = usePageStore();
  const { onSelectFile } = useFileSelector({
    multiple: true,
    setFiles: (files, documentId) => {
      if (files.length > 0 && documentId && typeof documentId === "string") {
        pageStore?.addDocumentUploads(documentId, files);
      }
    },
  });

  const selectedCategory = pageStore?.selectedCategory ?? null;
  const showValidationErrors = pageStore?.documentsValidationAttempt ?? false;
  const documentsContext = pageStore?.getDocumentsContext();
  const documents = buildCreateApplicationDocumentTableRows(
    selectedCategory,
    pageStore?.documentUploads ?? {},
    pageStore?.documentServerFiles ?? {},
    showValidationErrors,
    documentsContext,
  );

  useEffect(() => {
    pageStore?.syncDocumentsStepValid();
  }, [pageStore, selectedCategory]);

  const handleRemoveFile = useCallback(
    (documentId: string, fileKey: string) => {
      pageStore?.removeDocumentFile(documentId, fileKey);
    },
    [pageStore],
  );

  return (
    <div className={cn("bg-neutrals-white flex flex-col gap-4 rounded-[14px] px-6 py-8", className)}>
      <CreateApplicationDocumentsHelpSection />
      <CreateApplicationDocumentsList documents={documents} onUploadClick={onSelectFile} onRemoveFile={handleRemoveFile} />
    </div>
  );
});
